import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './UnitConfiguration.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import { initialUnitConfigurationState, initialModelVariantState } from '../../reducers/initialState';
import { Navigate } from 'react-router-dom';
import UnitConfigurationPartsContainer from '../UnitConfigurationParts/UnitConfigurationPartsContainer';
import Banner from '../Banner/Banner';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Collapse from 'react-bootstrap/Collapse';
import collapseDown from '../../assets/collapse-down.svg';
import collapseUp from '../../assets/collapse-up.svg';
import ContentTemplate from '../ContentTemplate/ContentTemplate';
import { WidgetVisibility, IsWidgetAccessible } from '../../utils/widgetManager';
import UnitModel from './UnitModel';
import { v4 as uuid } from 'uuid';

const UnitConfiguration = ({
  unitManager = initialUnitConfigurationState.unitManager,
  unitConfiguration = initialUnitConfigurationState.unitConfiguration,
  userProfileWidgets,
  getModelComponentPositions,
  saveUnitDetails,
  getSelectedUserProfileWidgets,
  getOrganisationRegionByOrgId,
  getUnitManagerAndEngineers,
  currentTimezone,
  intl
}) => {
  const ModelVariantId = unitManager.selectedUnit.ModelVariantId;
  const UnitId = unitManager.selectedUnit.UnitId;
  const ModelId = unitManager.selectedUnit.ModelId;
  const modelComponentPositions = unitManager.selectedUnit.unitComponentPositions.filter(x => !x.IsVirtual);

  const [unitModelOpen, setUnitModelOpen] = useState(true);
  const [partsOpen, setPartsOpen] = useState(false);

  let redirect = false;

  useEffect(() => {
    getModelComponentPositions(ModelId, null, true);
  }, [getModelComponentPositions, ModelId]);

  let messageId = (unitConfiguration && unitConfiguration.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  return (
    <div className={s.unitConfiguration}>
      <Banner
        key={uuid()}
        failureText={messageText}
        showBanner={unitConfiguration.showBanner}
        status={unitConfiguration.isOpSuccessful}
        successText={messageText}
      />
      {redirect ? <Navigate to="/units" /> : ''}
      <ContentTemplate
        selectedPage="unitConfiguration"
        userProfileWidgets={userProfileWidgets}
        widgetCode={'UNIT_CONFIGURATION'}
        tagoutRequired={false}
      >
        <div className={s.contentWrapper}>
          <div className={s.modelvariantContent}>
            <div className={`${s.titleRows}`}>
              <Row>
                <Col xs={12} md={6}>
                  <Row>
                    <img
                      src={unitModelOpen ? collapseDown : collapseUp}
                      alt="Collapse section"
                      onClick={() => setUnitModelOpen(!unitModelOpen)}
                      aria-controls="unit-model-section"
                      aria-expanded={unitModelOpen}
                    ></img>
                    <h4>
                      <FormattedMessage id="unitConfiguration.infomation" defaultMessage="Unit Information" />
                    </h4>
                  </Row>
                </Col>
              </Row>
              <Collapse in={unitModelOpen}>
                <div id="unit-model-section">
                  <UnitModel
                    getSelectedUserProfileWidgets={getSelectedUserProfileWidgets}
                    getOrganisationRegionByOrgId={getOrganisationRegionByOrgId}
                    getUnitManagerAndEngineers={getUnitManagerAndEngineers}
                    userProfileWidgets={userProfileWidgets}
                    unitManager={unitManager}
                    intl={intl}
                    currentTimezone={currentTimezone}
                    onSave={saveUnitDetails}
                  />
                </div>
              </Collapse>
            </div>
            {IsWidgetAccessible(userProfileWidgets, 'UNIT_PARTS') &&
              <div className={s.titleRows} style={WidgetVisibility(userProfileWidgets, 'UNIT_PARTS')}>
                <Row>
                  <Col xs={12} md={6}>
                    <Row>
                      <img
                        src={partsOpen ? collapseDown : collapseUp}
                        alt="Collapse section"
                        onClick={() => setPartsOpen(!partsOpen)}
                        aria-controls="parts-section"
                        aria-expanded={partsOpen}
                      ></img>
                      <h4>
                        <FormattedMessage id="componentParts.parts" defaultMessage="Parts" />
                      </h4>
                      <span className={s.circle}>
                        {unitConfiguration &&
                          unitConfiguration.componentParts &&
                          unitConfiguration.componentParts.componentPartsList &&
                          unitConfiguration.componentParts.componentPartsList.length}
                      </span>
                    </Row>
                  </Col>
                </Row>
                <Collapse in={partsOpen}>
                  <div className={s.innerComponent} id="parts-section">
                    <UnitConfigurationPartsContainer
                      UnitId={UnitId}
                      userProfileWidgets={userProfileWidgets}
                      modelComponentPositions={modelComponentPositions}
                    ></UnitConfigurationPartsContainer>
                  </div>
                </Collapse>
              </div>
            }
          </div>
        </div>
      </ContentTemplate>
    </div>
  );
};


UnitConfiguration.propTypes = {
  unitConfiguration: PropTypes.object.isRequired,
  unitManager: PropTypes.object.isRequired,
  userProfileWidgets: PropTypes.object.isRequired,
  modelVariantManager: PropTypes.object.isRequired,
  getModelComponentPositions: PropTypes.func.isRequired
};

export default injectIntl(UnitConfiguration);
